import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDropzone } from 'react-dropzone';
import { useAuth } from '../context/AuthContext';
import { useUpload } from '../context/UploadContext';
import { notify } from '../utils/notifications';
import '../styles/NewCase.css';

function NewCase() {
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [isCreating, setIsCreating] = useState(false);
    const { user, userProfile } = useAuth();
    const facilityType = userProfile?.facility_type || 'ipr';
    const navigate = useNavigate();
    const { startCaseUpload } = useUpload();

    const onDrop = (acceptedFiles) => {
        setSelectedFiles(acceptedFiles);
    };

    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
        accept: {
            'application/pdf': ['.pdf'],
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx']
        },
        multiple: true
    });

    const handleFileUpload = async (e) => {
        e.preventDefault();
        if (selectedFiles.length === 0 || !user?.uid) return;

        setIsCreating(true);

        try {
            const caseId = await startCaseUpload(selectedFiles, { facilityType });
            navigate(`/case/${caseId}`);
        } catch (error) {
            console.error('Error creating case:', error);
            let errorMessage = 'Failed to create case. ';

            if (error.response?.data?.details) {
                errorMessage += error.response.data.details;
            } else if (error.response?.data?.error) {
                errorMessage += error.response.data.error;
            } else {
                errorMessage += 'Please try again.';
            }

            notify.error(errorMessage);
        } finally {
            setIsCreating(false);
        }
    };

    return (
        <div className="new-case-container">
            <h1>Create New Cases</h1>
            <div className="upload-container">
                <form onSubmit={handleFileUpload} className="upload-form">
                    <div {...getRootProps()} className="dropzone">
                        <input {...getInputProps()} />
                        {isDragActive ? (
                            <p>Drop the files here ...</p>
                        ) : (
                            <p>Drag and drop PDF or DOCX files here, or click to select files</p>
                        )}
                        {selectedFiles.length > 0 && (
                            <div className="selected-files">
                                <p>Selected files:</p>
                                <ul>
                                    {selectedFiles.map(file => (
                                        <li key={file.name}>{file.name}</li>
                                    ))}
                                </ul>
                            </div>
                        )}
                    </div>
                    <button
                        type="submit"
                        className="upload-button"
                        disabled={selectedFiles.length === 0 || isCreating}
                    >
                        {isCreating ? 'Creating case...' : 'Upload and Create Cases'}
                    </button>
                </form>
            </div>
        </div>
    );
}

export default NewCase;
